import { configureTokenInterceptor } from "@/config/interceptors";
import axios from "axios";

export const api = axios.create({
  baseURL: process.env.EXPO_PUBLIC_INFLOW_API_URL,
  headers: { "content-Type": "application/json", Accept: "application/json" },
});

export const apiMock = axios.create({
  baseURL: "http://localhost:1080/",
  headers: { "content-Type": "application/json", Accept: "application/json" },
});

configureTokenInterceptor(api);
